import * as angular from 'angular';
import permissions from 'application/detail/permissions.json';
import { SchedulerController } from 'modules/application/detail/growth/scheduler/SchedulerController';
import SchedulerView from './SchedulerView.html';
import { ScheduleController } from 'modules/application/detail/growth/scheduler/schedule/ScheduleController';
import ScheduleView from './schedule/ScheduleView.html';
import { ScheduleItemComponent } from 'modules/application/detail/growth/scheduler/scheduleItem';
import { GrowthSegmentService } from '../GrowthSegmentService';
import { SchedulerService } from './SchedulerService';
export const growthState = 'auth.application.detail.growth';
export const schedulerState = 'auth.application.detail.growth.scheduler';
export const scheduler = angular
    .module('scheduler', ['ui.router'])
    .component('scheduleItem', ScheduleItemComponent)
    .service('GrowthSegmentService', GrowthSegmentService)
    .service('SchedulerService', SchedulerService)
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state(schedulerState, {
            url: '/scheduler',
            views: {
                'content@auth.application.detail': {
                    template: SchedulerView,
                    controller: SchedulerController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.scheduler.claim,
            },
            params: { area: 'scheduler' },
        })
            .state('auth.application.detail.growth.scheduler.schedule', {
            url: '/schedule/:id',
            views: {
                'content@auth.application.detail': {
                    template: ScheduleView,
                    controller: ScheduleController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.scheduler.claim,
            },
            params: { area: 'scheduler' },
        });
    }]).name;
